import { render, staticRenderFns } from "./EstoqueMenu.vue?vue&type=template&id=1fdaaaa2&scoped=true"
import script from "./EstoqueMenu.vue?vue&type=script&lang=js"
export * from "./EstoqueMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdaaaa2",
  null
  
)

export default component.exports